/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetAgreementRequests200ResponseInner
 */
export interface GetAgreementRequests200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'agreementRequestId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'agreementId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'requestDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'agreementStatus': GetAgreementRequests200ResponseInnerAgreementStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'isRequired': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'submittedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAgreementRequests200ResponseInner
     */
    'submittedAt': string | null;
}

export const GetAgreementRequests200ResponseInnerAgreementStatusEnum = {
    notAgreed: 'NOT_AGREED',
    agreed: 'AGREED',
    disagreed: 'DISAGREED'
} as const;

export type GetAgreementRequests200ResponseInnerAgreementStatusEnum = typeof GetAgreementRequests200ResponseInnerAgreementStatusEnum[keyof typeof GetAgreementRequests200ResponseInnerAgreementStatusEnum];


